// @vendors
import { Outlet } from 'react-router-dom'

// @store
import { useThemeStore } from '../../store/useThemeStore';
import SidebarProfileUser from './components/SidebarProfileUser';

const ProfileUser = () => {
    const { isDarkMode } = useThemeStore();

    return (
        <div className={`flex p-2 lg:p-4 gap-[30px] h-[81vh] overflow-auto ${isDarkMode ? "dark" : ""} bg-white dark:bg-dark-cBackground`}>
            <SidebarProfileUser />
            <div className="flex-1 overflow-hidden pb-[0px]">
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-white dark:bg-dark-cBackground text-cText dark:text-white">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}

export default ProfileUser